import * as _ from 'lodash';
import { objectGroupsByParam } from '../../services/available-filters/available-filters.commercial';

/** @type {string} str */
function isUppercase(str) {
  return str === str.toUpperCase();
}

export default angular.module('cian.newbuild.filter.serpFilterAssociatedObjects', [])
  .directive('serpFilterAssociatedObjects', () => ({
    restrict: 'E',
    template: `
      <div
        ng-if="associatedObjects.text"
        ng-style="associatedObjects.style"
      >
        ({$ associatedObjects.text $})
      </div>
    `,
    scope: {},
    bindToController: {
      filterParam: '@',
      position: '@?',
    },
    controller: [
      '$element',
      '$scope',
      'FilterService',
      'FilterObjectTypeService',
      function ($element, $scope, FilterService, FilterObjectTypeService) {
        const ctrl = this;

        const isInline = ctrl.position === 'inline';

        ctrl.style = isInline ? {
          'margin-left': '.3em',
        } : {
          'white-space': 'normal',
        };

        const associatedObjects = objectGroupsByParam[ctrl.filterParam];
        const selectedObjects = FilterService.objectTypes.map(o => o.name);
        const objectsToDisplay = _.intersection(associatedObjects, selectedObjects);

        if (associatedObjects && selectedObjects.length > objectsToDisplay.length) {
          ctrl.text = objectsToDisplay
            .map(FilterObjectTypeService.getObjectTypeByName)
            .map(object => {
              /** @type {string} */
              const objectText = object.title || object.text;
              return isUppercase(objectText) ? objectText : objectText.toLowerCase();
            })
            .join(', ');
        } else {
          $element.remove();
          $scope.$destroy();
        }

        return ctrl;
      }],
    controllerAs: 'associatedObjects',
  }))
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/serp-filter-associated-objects/serp-filter-associated-objects.dir.js